import { init } from './methods/init/init';
import { send } from './methods/send/send';
import { sendForm } from './methods/sendForm/sendForm';
export { init, send, sendForm };
export default {
  init: init,
  send: send,
  sendForm: sendForm
};